/**
 * Manages user feeds api interactions
 *
 * Copyright (c) 2019 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import axios from 'axios'
import queryString from 'query-string'
import apiConfig from 'common/configs/api'
import { getHeaders } from '../../auth/api'

const { apiUrl, users, batch } = apiConfig
const { feeds } = users
const usersUrl = `${apiUrl}${users.url}`
const batchDeleteUrl = `${batch.url}${batch.delete}`

export const getStreamTokens = (userId) => {
  const feedsTokenUrl = `${usersUrl}/${userId}${feeds.url}${feeds.tokens}`
  const headers = getHeaders()

  return axios.get(feedsTokenUrl, { headers })
}

export const getNotificationFeed = (userId, options) => {
  const queryOptions = (options instanceof Object) ? `?${queryString.stringify(options)}` : ''
  const headers = getHeaders()
  const notificationFeedUrl = `${usersUrl}/${userId}${feeds.url}${feeds.notification}${queryOptions}`

  return axios.get(notificationFeedUrl, { headers })
}

export const deleteNotificationActivity = (userId, activityId) => {
  const headers = getHeaders()
  const deleteNotificationActivityUrl = `${usersUrl}/${userId}${feeds.url}${feeds.notification}/${activityId}`

  return axios.delete(deleteNotificationActivityUrl, { headers })
}

export const deleteNotificationActivities = (userId, data) => {
  const headers = getHeaders()
  const deleteNotificationActivitiesUrl = `${usersUrl}/${userId}${feeds.url}${feeds.notification}${batchDeleteUrl}`

  return axios.post(deleteNotificationActivitiesUrl, data, { headers })
}
